import Vue from 'vue';
import api from '../bu/api';

export default {
    namespaced: true,

    state: () => ({
        currentPagination: null,
        countByTypes: null
    }),

    getters: {
        currentPagination(state) {
            return state.currentPagination;
        },
        countByTypes(state) {
            return state.countByTypes;
        }
    },

    actions: {
        resetLoadedNotifications({commit}) {
            commit('processPagination', null);
        },
        async getCountByTypes({ commit }) {
            const response = await api.getNotificationCountByTypes();
            commit('setCountByTypes', response.data);
        },
        async getNotifications({ commit }, { page, type }) {
            const response = await api.getNotifications(page, type);
            commit('processPagination', response.data);
        },
        async markRead({state, commit}, notificationId) {
            const response = await api.markNotificaionAsRead(notificationId);
            commit('markNotificationRead', notificationId);

            window.fullyReloadNotificationDropDown && window.fullyReloadNotificationDropDown();
        },
        async markAllAsRead({state, commit}) {
            await api.markAllNotificaionAsRead();
            window.fullyReloadNotificationDropDown && window.fullyReloadNotificationDropDown();
        }
    },

    mutations: {
        processPagination(state, pagination) {
            Vue.set(state, 'currentPagination', pagination);
        },
        markNotificationRead(state, id) {
            state.currentPagination.data.find((item) => item.id == id).read_at = true;
        },
        setCountByTypes(state, countByTypes) {
            state.countByTypes = countByTypes;
        }
    },
}